import { useState, useCallback } from 'react';
import axios from 'axios';
import { toast } from 'sonner';

/**
 * Shared hook for upgrading to Besume Pro.
 * Calls POST /api/checkout/create-session and redirects to Stripe.
 * Use this everywhere an "Upgrade to Pro" button exists.
 */
export function useUpgrade() {
  const [upgrading, setUpgrading] = useState(false);

  const handleUpgrade = useCallback(async () => {
    setUpgrading(true);
    try {
      const res = await axios.post('/api/checkout/create-session', {
        origin_url: window.location.origin
      });
      if (res.data.url) {
        window.location.href = res.data.url;
      } else {
        toast.error('Something went wrong. Please try again.');
        setUpgrading(false);
      }
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Something went wrong. Please try again.');
      setUpgrading(false);
    }
  }, []);

  return { upgrading, handleUpgrade };
}
